import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updateMemberJournal = ({
  churchId,
  journalId,
  memberJournalData
}) => {
  return axios.post(
    `/churches/${churchId}/member-journals/${journalId}?_method=PATCH`,
    memberJournalData
  );
};

export const useUpdateMemberJournal = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("member-journals");

      setNotification({
        type: "success",
        message: "Member journal updated successfully!"
      });
    },
    ...config,
    mutationFn: updateMemberJournal
  });
};
